/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetSharedWorkspacesResponse } from '../../models/get-shared-workspaces-response';

export interface GetSharedWorkspaces$Params {
}

export function getSharedWorkspaces(http: HttpClient, rootUrl: string, params?: GetSharedWorkspaces$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSharedWorkspacesResponse>> {
  const rb = new RequestBuilder(rootUrl, getSharedWorkspaces.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetSharedWorkspacesResponse>;
    })
  );
}

getSharedWorkspaces.PATH = '/workspaces/shared';
